<template>
<div class="header-padding">
    <b-container class="my-3">      
        <page-show :alias="'contacts'"></page-show>     
        <div class="map mb-5">
            <img src="@/assets/images/russia.svg" alt="логоитип" width="100%"> 
            <div class="marker sakh">
                <img src="@/assets/images/logo.svg" alt="логоитип">
                <div class="label">
                    <span>Южно-Сахалинск</span>
                </div>
            </div>
            <div class="marker vlad">
                <img src="@/assets/images/logo.svg" alt="логоитип">
                <div class="label">
                    <span>Владивосток</span>
                </div>
            </div>
            <div class="marker habar">
                <img src="@/assets/images/logo.svg" alt="логоитип">
                <div class="label">
                    <span>Хабаровск</span>                    
                </div>
            </div>
            
        </div>         
        
    </b-container>
</div>
</template>

<script>
import PageShow from "@/components/components/PageShow";
export default {
    components:{
        'page-show':PageShow
    }
}
</script>

<style lang="scss">
    .map{
        width: 90%;
        margin: auto;
        display: block;
        position: relative;
        .marker{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: rgb(187 187 187 / 82%);
            box-shadow: 0 0 20px 1px #000;            
            position: absolute;
            text-align: center;
            .label{
                position: relative;
                display: none;
                font-size: 12px;
                white-space: nowrap;                
                span{
                    position: absolute;   
                    display: block;   
                    background-color: #fff;
                    padding: 5px;   
                    border-radius: 3px;
                    border:1px solid #aaa;           
                }
            }
            &.sakh{
                top:79%; 
                right: 7%;
                &:hover{
                    .label{
                        display: block;
                    }
                }
            }
            &.vlad{
                top:98%; 
                right: 13%;
                &:hover{
                    .label{
                        display: block;
                    }
                }
            }
            &.habar{
                top: 81%;
                right: 13%;
                &:hover{
                    .label{
                        display: block;
                    }
                }
            }
            img{
                width: 20px;
                vertical-align: top;
                border-style: none;
            }
        }
    }
    @media(max-width:420px){
        .map{
            width: 100%;
            .marker{
            width: 10px;
            height: 10px;
            background-color: rgb(187 187 187 / 82%);
            box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.815);            
            img{
                width: 10px;
            }
        }
        }
    }
</style>
